// src/Components/Forms/Financement/Salam/Validation/Tab3.tsx
import React from 'react';
import { Box, Grid, Alert } from '@mui/material';
import ReadOnlyDocumentList from '../../../../ReadOnlyDocumentList';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import SetMultipleDocument from '../../../../SetMultipleDocument';

// ==================== PARAMÈTRES DE RECHERCHE ====================
let searchDocument: ParamsPicklist = {
  CodeAgence: 'SALAM',
  Table: 'vw_DocumentsParEtape',
  Colonne1: 'CodeEtape',
  Colonne2: '',
  Colagence: 'CodeProcessus',
  Init: 'VALIDATION',
  Choix: 34,
};

// ==================== INTERFACE DES PROPS ====================
interface Tab3Props {
  /** Liste des documents déjà associés à la demande (lecture seule) */
  documents?: any[];
  /** Instance du Form AntD du parent */
  form: any;
  /** Hauteur maximale du panneau (défaut : calculée pour laisser voir le tableau du bas) */
  maxHeight?: number | string;
}

// ==================== COMPOSANT ====================
const Tab3: React.FC<Tab3Props> = ({
  documents = [],
  form,
  maxHeight = '480px',   // ← laisse ~480 px pour le tableau du bas
}) => {
  // Sécurité : si le parent oublie de passer `form`, on affiche un message clair
  if (!form) {
    return (
      <div className="tabItem">
        <Box width="85%" sx={{ p: 2 }}>
          <Alert severity="error">
            Formulaire non transmis. Vérifiez que <code>&lt;Tab3 form=&#123;form&#125; /&gt;</code> est correctement configuré.
          </Alert>
        </Box>
      </div>
    );
  }

  return (
    <div className="tabItem">
      {/*
        ✅ Conteneur scrollable :
        - maxHeight → limite la hauteur pour ne pas pousser le tableau du bas hors écran
        - overflowY: 'auto' → scroll vertical si le contenu dépasse
        - overflowX: 'hidden' → pas de scroll horizontal (le contenu s'adapte)
        - pr: 1 → petit padding à droite pour ne pas coller la scrollbar aux champs
      */}
      <Box
        fontStyle="inherit"
        className="border"
        width="85%"
        sx={{
          p: 2,
          pr: 1.5,
          position: 'relative',
          maxHeight,
          overflowY: 'auto',
          overflowX: 'hidden',
          // Style de la scrollbar (optionnel, compatible Chrome/Edge)
          '&::-webkit-scrollbar': { width: 8 },
          '&::-webkit-scrollbar-track': { bgcolor: '#f1f5f9', borderRadius: 4 },
          '&::-webkit-scrollbar-thumb': { bgcolor: '#c5d8ea', borderRadius: 4, '&:hover': { bgcolor: '#2A6596' } },
        }}
      >
        {/* ===== Section 1 : Sélection des documents à joindre ===== */}
        <Grid container spacing={0}>
          <Grid item xs={12} md={12} lg={12}>
            <SetMultipleDocument
              form={form}
              Size="large"
              width={4}
              label="Documents"
              name="Document"
              Parametre={searchDocument}
            />
          </Grid>
        </Grid>

        {/* ===== Section 2 : Liste en lecture seule des documents joints ===== */}
        {documents.length > 0 && (
          <Box sx={{ mt: 3 }}>
            <ReadOnlyDocumentList documents={documents} />
          </Box>
        )}
      </Box>
    </div>
  );
};

export default Tab3;